import { Layout } from 'antd'
import classNames from 'classnames'
import { FC, ReactNode } from 'react'

const { Sider } = Layout

export const SidebarComponent: FC<{ children: ReactNode; collapsed: boolean; setCollapsed: (collapsed: boolean) => void }> = ({
  children,
  collapsed,
  setCollapsed,
}): JSX.Element => {
  return (
    <Sider
      collapsible
      collapsed={collapsed}
      collapsedWidth="60"
      onCollapse={(close) => setCollapsed(close)}
      className={classNames({ 'per-collapsed': collapsed })}
    >
      {children}
    </Sider>
  )
}
